import axios from "axios";

function req(config) {
  return {
    ...config,
    headers: {
      "Lianjia-Device-Id": window.saasHeaders.LianjiaDeviceId,
      "Lianjia-Device-Type": window.saasHeaders.LianjiaDeviceType,
      "App-Version": window.saasHeaders.AppVersion,
      "Web-Type": window.saasHeaders.WebType,
      "Lianjia-Access-Token": window.saasHeaders.LianjiaAccessToken,
      channel: window.saasHeaders.channel
    }
  };
}
function reqError(error) {
  return Promise.reject(error);
}

function res(response) {
  if (response.status === 200) {
    return response.data;
  } else {
    return response;
  }
}
function resError(error) {
  return Promise.reject(error);
}

export const reqbase = servicePath => {
  const reqInstance = axios.create({
    baseURL: servicePath,
    timeout: 20000,
    params: { json: "" },
    data: { json: "" }
  });
  // 添加请求拦截器
  reqInstance.interceptors.request.use(req, reqError);
  // 添加响应拦截器
  reqInstance.interceptors.response.use(res, resError);
  return reqInstance;
};

export const commonRequest = reqbase("");

export default reqbase("/promote");
